import React from 'react';
import {
    PanelHeader,
    Div,
    Spinner,
    SplitCol,
    SplitLayout,
    Button,
    Search, ButtonGroup, ModalRoot, ModalPage, ModalPageHeader, PanelHeaderButton
} from '@vkontakte/vkui';
import axios from "axios";

import {
    Icon24BrowserBack,
    Icon24Info
} from "@vkontakte/icons";
import IncomingProducts from "./IncomingProducts";
import {AdaptivityContext, setQuizStep} from "../assets/constants";
import * as constants from "../assets/constants";
import IncomingDocsViewer from "./IncomingDocsViewer";
import IncomingStepHeader from "./StepHeader";


class IncomingStep3 extends React.Component {

    state = {
        mainSearch: '',
        items: [],
        cnt_products: 0,
        loading: true
    }

    constructor(props) {
        super(props);
    }


    getItems = () => {
        clearInterval(this.searchInterval);

        this.setState({loading: true})

        let body = new FormData()
        body.append('ids', JSON.stringify(this.props.ids))

        axios.post(this.props.base_url + '?app=incomings&act=getDocItems', body,
            {
                withCredentials: true

            }
        ).then((response) => {
            this.setState({loading: false, items: response.data.items ?? []})


            this.setState({cnt_products: response.data.items ? response.data.items.length : 0})

        })

    }

    componentDidMount() {
        this.getItems()
    }

    onSearchChange = (e) => {
        this.setState({mainSearch: e.target.value})
    }

    render() {
        const images_url = this.props.base_url.replace("frontend/", '');

        return (
            <SplitLayout >
                <SplitCol>
                    <PanelHeader fixed={true}>
                        <Div>
                            Приемка. Шаг 3
                        </Div>
                    </PanelHeader>
                    <IncomingStepHeader currentDocs={this.props.currentDocs} onSearchChange={this.onSearchChange} step={3}/>
                    <SplitLayout>
                        <SplitCol>
                            {this.state.loading ? <Spinner size="large"/> : ''}
                            <IncomingProducts items={this.state.items}
                                              search={this.state.mainSearch}
                                              base_url={this.props.base_url}
                                              images_url={images_url}
                                              current_user={this.props.current_user}
                                              currentDocs={this.props.currentDocs}/>
                        </SplitCol>
                    </SplitLayout>
                    <SplitLayout>
                        <SplitCol>
                            <Div className="action-board">
                                <ButtonGroup mode="horizontal" stretched>
                                    <Button stretched size={AdaptivityContext.isMobile ? 'm' : 'l'}
                                            onClick={() => setQuizStep(2, 'Incoming')}>Назад</Button>
                                    <Button stretched size={AdaptivityContext.isMobile ? 'm' : 'l'}
                                            onClick={() => setQuizStep(4, 'Incoming')}>Далее</Button>
                                </ButtonGroup>
                            </Div>
                        </SplitCol>
                    </SplitLayout>
                </SplitCol>
            </SplitLayout>)
    }


}

export default IncomingStep3